import { render, staticRenderFns } from "./productocaracteristicaEdit.vue?vue&type=template&id=02a5d8c3&"
import script from "./productocaracteristicaEdit.vue?vue&type=script&lang=js&"
export * from "./productocaracteristicaEdit.vue?vue&type=script&lang=js&"
import style0 from "./productocaracteristicaEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports